import React, { useEffect } from 'react';
import '../../ressources/styles/contact.css';
import Mallette from '../../ressources/images/Logo_mallette.svg';
import Devanture from '../../ressources/images/facade immeuble 2.webp';
import Typewriter from 'typewriter-effect/dist/core';
import Form from './Content/Form';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation();
  
  useEffect(() => {
    new Typewriter('#typewriter', {
      strings: [t("contact_parlons"), t("contact_qui")],
      autoStart: true,
      loop: true,
      deleteSpeed: 10,
      delay: 100,
    });
  }, );

  const handleArrowClick = () => {
    window.scrollTo({
      top: document.getElementById('map').offsetTop - 100,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <Helmet>
        <title>{t("contact_title")}</title>
      </Helmet>
      <div className='wrapper font-mtserrat test min-h-screen flex flex-col justify-center items-center pt-24 pb-12 lg:py-0 lg:flex-row lg:gap-20 px-6'>
        <div className='flex flex-col gap-6 w-full lg:w-1/2 items-center justify-center my-auto'>
          <h1 className='text-4xl font-bold text-center sm:text-5xl md:text-6xl w-full min-h-[2.4em] md:min-h-[1.2em] leading-tight'><span id="typewriter"></span></h1>
          <p className='font-bold text-gray-400 text-center text-base md:text-lg max-w-md'>{t("contact_creons")}</p>
          <div className='mail-at-container flex p-4 items-center gap-5 rounded-xl z-2 bg-white w-full md:w-[350px] lg:w-[400px]'>
            <img src={Mallette}  alt='mallette' className='h-9'/>
            <div className='leading-4 '>
              <p className='text-sm font-semibold'> {t("contact_ecrire")}</p>
              <a href={`mailto:${t("contact_mail")}`}>
                <span className='text-sm font-bold text-primOrange'>
                  {t("contact_mail")}
                </span>
              </a>
            </div>
          </div>
            <div className='mail-at-container flex p-4 items-center gap-5 rounded-xl z-2 bg-white w-full md:w-[350px] lg:w-[400px]'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FF8C00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
              </svg>
            <div className='leading-4 '>
              <p className='text-sm font-semibold'> {t("contact_appeler")}</p>
              <a href={`tel:${t("contact_telephone")}`}>
                <span className='text-sm font-bold text-primOrange'>
                  {t("contact_telephone")}
                </span>
              </a>
            </div>
          </div>
          <div className="h-12 w-full flex items-center justify-center flex-col lg:justify-start mt-10">
            <p className='paragraphe mb-6'> {t("contact_carte")}</p>
            <div className="h-16 w-16 rounded-full animate-bounce cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" onClick={handleArrowClick}> 
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
              </svg>
            </div>
          </div>
        </div>
        <GoogleReCaptchaProvider reCaptchaKey="6LfVH7AtAAAAAOHFjRPLD2eeFxwfunQBlWANOvDK">
          <div className='lg:w-1/2 lg:pb-[2vh]'>
            <Form />
          </div>
        </GoogleReCaptchaProvider>
      </div>

      <div className='w-full pt-24 pb-3 px-3 md:py-4 md:px-4 flex gap-5 flex-col justify-center md:flex-row'  id="map">
        <div className='flex-1'>
          <img src={Devanture} alt="79a rue de la Plaine des bouchers, 67100 Strasbourg" className='w-full h-auto object-cover' />
        </div>
        <div className='flex-1 min-h-[300px] md:min-h-full flex'>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17786.138804064456!2d7.737893273495516!3d48.56541953453263!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4796c997d96aaaab%3A0xfe88b3f41a38348e!2s79a%20Rue%20de%20la%20Plaine%20des%20Bouchers%2C%2067100%20Strasbourg!5e0!3m2!1sfr!2sfr!4v1687337153982!5m2!1sfr!2sfr" className="w-full flex-1" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="maps" ></iframe>
        </div>
      </div>
    </>
  )
}

